module.exports = __webpack_public_path__ + "05349fbe7a59ba6769ad5439da23fec0.pdf";